import { render, staticRenderFns } from "./DIVETools.vue?vue&type=template&id=3d4a644e"
import script from "./DIVETools.vue?vue&type=script&lang=ts"
export * from "./DIVETools.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports